
const getCookie = (name: string): string | undefined => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
    return undefined;
};

export const jwtToken = (): string | undefined => {
  const cookieValue = getCookie('currentUser');
  if (!cookieValue) return undefined;

  const decoded = decodeURIComponent(cookieValue);
  const data = JSON.parse(decoded);
  const tokenInfo = data?.token?.toString();
  return tokenInfo;
}

export const decodeJwtPayload = (): any => {
  const cookieValue = getCookie('currentUser');
  if (!cookieValue) return undefined;

  const decoded = decodeURIComponent(cookieValue);
  const data = JSON.parse(decoded);
  const tokenInfo = data?.token?.toString();
  const payload = tokenInfo.split('.')[1];
  const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
  const json = decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );
  return JSON.parse(json);
}
